import React from "react";
import { connect } from 'react-redux';
import { Card, CardHeader, CardBody, Badge } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import CertificateCard from './CertificateCard.jsx';
import CertificateViewer from './CertificateViewer.jsx';

class CertificateList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selectedCertificate: null,
      showViewer: false
    };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    if (this.props.userId) {
      await this.helper.badge().getCertificatesByUser(this.props.userId);
    }
    this.setState({ loading: false });
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId && this.props.userId) {
      this.setState({ loading: true });
      await this.helper.badge().getCertificatesByUser(this.props.userId);
      this.setState({ loading: false });
    }
  }

  openViewer(certificate) {
    this.setState({ selectedCertificate: certificate, showViewer: true });
  }

  closeViewer() {
    this.setState({ selectedCertificate: null, showViewer: false });
  }

  render() {

    var certificates = this.props.badge.certificates || [];
    var translate = this.props.translate || {};

    if (this.state.loading) {
      return (
        <Card className="shadow">
          <CardBody className="text-center py-5">
            <i className="fas fa-spinner fa-spin fa-2x text-muted" />
          </CardBody>
        </Card>
      );
    }

    return (
      <React.Fragment>
        <Card className="shadow">
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              <i className="fas fa-graduation-cap mr-2" />
              {translate['certificados'] || 'Certificados'}
            </h5>
            <Badge color="danger" pill>{certificates.length}</Badge>
          </CardHeader>
          <CardBody>
            {certificates.length === 0 ? (
              <div className="text-center py-4">
                <i className="fas fa-graduation-cap fa-3x text-muted mb-3" style={{ opacity: 0.3 }} />
                <p className="text-muted">{translate['sem_certificados'] || 'Nenhum certificado emitido ainda'}</p>
              </div>
            ) : (
              certificates.map((cert) => (
                <CertificateCard
                  key={cert.id}
                  certificate={cert}
                  onClick={(c) => this.openViewer(c)}
                />
              ))
            )}
          </CardBody>
        </Card>

        {this.state.showViewer && this.state.selectedCertificate && (
          <CertificateViewer
            certificate={this.state.selectedCertificate}
            userName={this.props.user.name + ' ' + (this.props.user.lastName || '')}
            onClose={() => this.closeViewer()}
          />
        )}
      </React.Fragment>
    );

  }

}

export default connect(state => ({
  badge: state.badge,
  translate: state.translate,
  user: state.user
}))(CertificateList);
